import { parseDef } from "../parseDef.js";
export const parseCatchDef = (def, refs) => {
    return parseDef(def.innerType._def, refs);
};
